import React from 'react';
import {
    Box,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    List,
    ListItem, ListItemText,
    Typography
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const EvaluatorCard = ({ attributeType, description, cardClasses, expanded, handleExpand}) => (
    <>
        {description.map((content, idx) => {
            const { value } = content;
            
            const rules = value.split('(')[1].split(',');
            return (
                <ExpansionPanel
                    className={cardClasses.expansionPanel}
                    key={idx.toString()}
                    expanded={expanded === `email-${idx}`}
                    onChange={handleExpand(`email-${idx}`)}
                >
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls={`email-${idx}-content`}
                        id={`email-${idx}-header`}
                    >
                        <Typography
                            variant="body2"
                            paragraph
                        >
                            {attributeType === 'EMAIL' ? (
                              <>
                                  {`Email Evaluator-${idx + 1}`}
                              </>
                            ) : attributeType === 'CAR_LOAN' ?
                                (<>
                                    {`Title Questions Evaluator-${idx + 1}`}
                                </>)
                                : (
                                <>
                                    {`Self Employed Evaluator-${idx + 1}`}
                                </>
                            )}
                        </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                        <List>
                            <>
                                {rules.map((rule, ruleIdx) => {
                                    const values = Array.from(new URLSearchParams(rule.trim().replace(')', '')).entries()).reduce((a, [k, v]) => ((a[k] = v, a)), {});
                                    const obj = Object.entries(values)[0];
                                    let value = '';
                                    switch (obj[1]) {
                                        case 'true':
                                            value = "True"
                                            break;
                                        case 'false':
                                            value = "False"
                                            break;
                                        default:
                                            value = obj[1];
                                    }
                                    return (
                                        <ListItem
                                            key={`${idx.toString()}-${ruleIdx.toString()}`}>
                                            <ListItemText>
                                                <Box display="flex" alignItems="flex-start" justifyContent="space-between">
                                                    <Box display="flex" alignItems="center" justifyContent="space-between"
                                                         flexDirection="row">
                                                        <Typography variant="body2">
                                                            {obj[0]}:{value}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </ListItemText>
                                        </ListItem>
                                    );
                                })}
                            </>
                        </List>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            )

        })}
    </>
);

export default EvaluatorCard;
